<article
    class="page lookup"
    [class.center-field-vertically]="centerFieldVertically$ | async | waitABit: { initial: true, delay: 400, immediate: !(centerFieldVertically$ | async) }"
>
    <div class="top-content" [class.expand]="!(showPage$ | async)">
        <app-bg fullPage [styles]="transitionScrollTop && { top: transitionScrollTop + 'px' }"></app-bg>
        <div class="header-placeholder"></div>
        <div class="form-container">
            <div class="form-centerer" [class.animated]="true | waitABit: { initial: false }" #formCenterer>
                <form autocomplete="off" [formGroup]="lookupForm" (ngSubmit)="onLookupEnter($event)">
                    <div class="welcome">
                        <ng-template #welcomeText>
                            <span class="inline-block">
                                Find information on
                                <span class="inline-block">
                                    taxes and make
                                    <span class="inline-block">tax payments:</span>
                                </span>
                            </span>
                        </ng-template>
                        <ng-container *ngIf="stateLoaded$ | async">
                            <ng-container *ngTemplateOutlet="welcomeText"></ng-container>
                        </ng-container>
                        <ng-container *ngIf="(stateLoaded$ | async) !== true">
                            <egov-text-ui-placeholder>
                                <ng-container *ngTemplateOutlet="welcomeText"></ng-container>
                            </egov-text-ui-placeholder>
                        </ng-container>
                    </div>
                    <div class="field" *ngIf="(serviceIsUnavailable$ | async) !== true; else serviceUnavailable">
                        <div class="option-and-input" [class.invisible]="(stateLoaded$ | async) !== true">
                            <div
                                class="tax-option"
                                [class.expanded]="taxOptionsExpanded"
                                [style.display]="(taxOptions$ | async)?.length < 2 ? 'none' : 'block'"
                            >
                                <div class="wide-screens" *ngIf="(viewport.width$ | async)! > 750; else taxOptionButtonsNarrow">
                                    <div
                                        class="buttons"
                                        [style.transform]="
                                            'translateY(calc(-100% / ' +
                                            (taxOptions$ | async)?.length +
                                            ' * ' +
                                            (taxOptionsExpanded ? (selectedTaxIndex$ | async) : 0) +
                                            '))'
                                        "
                                    >
                                        <button
                                            *ngFor="let option of taxOptions$ | async; let index = index"
                                            mat-button
                                            (click)="taxOptionsExpanded ? selectTax(option.id) : expandTaxOptions()"
                                            type="button"
                                            [class.current]="index === (selectedTaxIndex$ | async)"
                                        >
                                            {{ option.name }}
                                        </button>
                                    </div>
                                    <mat-icon class="expand-icon">expand_more</mat-icon>
                                </div>

                                <ng-template #taxOptionButtonsNarrow>
                                    <div
                                        class="narrow-screens"
                                        [class.collapsed]="!taxOptionsExpanded"
                                        [style.height]="(taxOptions$ | async)?.length * ((viewport.width$ | async)! <= 600 ? 45 : 58) + 'px'"
                                    >
                                        <div
                                            class="mover"
                                            [style.transform]="
                                                'translateY(calc(-100% / ' +
                                                (taxOptions$ | async)?.length +
                                                ' * ' +
                                                (taxOptionsExpanded ? 0 : (selectedTaxIndex$ | async)) +
                                                '))'
                                            "
                                        >
                                            <div class="buttons">
                                                <button
                                                    *ngFor="let option of taxOptions$ | async; let index = index"
                                                    mat-button
                                                    [attr.tabindex]="taxOptionsExpanded || (selectedTaxIndex$ | async) === index ? 1 : 0"
                                                    (click)="taxOptionsExpanded ? selectTax(option.id) : expandTaxOptions()"
                                                    type="button"
                                                >
                                                    {{ option.name }}
                                                </button>
                                            </div>
                                        </div>
                                        <mat-icon class="expand-icon">expand_more</mat-icon>
                                    </div>
                                </ng-template>
                            </div>
                            <div class="input">
                                <input
                                    type="text"
                                    spellcheck="false"
                                    [autofocus]="autofocus"
                                    #lookupField
                                    formControlName="lookupQuery"
                                    (focus)="lookupQueryHasFocus$.next(true)"
                                    (blur)="lookupQueryHasFocus$.next(false)"
                                    (keydown.arrowup)="selectPreviousSuggestion($event)"
                                    (keydown.arrowdown)="selectNextSuggestion($event)"
                                    (keydown.enter)="onLookupEnter($event)"
                                    [class.invisible]="selectedTaxServiceIsUnavailable$ | async"
                                />
                                <ng-container *ngIf="!(selectedTaxServiceIsUnavailable$ | async); else selectedServiceUnavailable">
                                    <label class="placeholder long" [class.invisible]="lookupQuery.value" for="lookup-field">
                                        {{ fieldInstructions$ | async }}
                                    </label>
                                    <label class="placeholder short" [class.invisible]="lookupQuery.value" for="lookup-field"> Search... </label>
                                </ng-container>
                                <ng-template #selectedServiceUnavailable>
                                    <label class="placeholder"> Service unavailable </label>
                                </ng-template>
                                <button mat-button type="submit" [disabled]="selectedTaxServiceIsUnavailable$ | async">
                                    <mat-icon>{{ (selectedTaxServiceIsUnavailable$ | async) ? "block" : "arrow_forward" }}</mat-icon>
                                </button>
                                <div class="suggestions-container" *ngIf="showSuggestions$ | async" #suggestionsContainer>
                                    <div class="suggestions">
                                        <div class="no-results" *ngIf="(suggestions && !thereAreSuggestions) || suggestionsError">
                                            <span class="text">
                                                <ng-container *ngIf="suggestions && !thereAreSuggestions"> No matches </ng-container>
                                                <ng-container *ngIf="suggestionsError"> Couldn't retrieve suggestions </ng-container>
                                            </span>
                                        </div>
                                        <ul *ngIf="suggestions && thereAreSuggestions">
                                            <li *ngFor="let match of suggestions; let index = index">
                                                <button
                                                    [class.active]="index === currentSuggestion"
                                                    (mousedown)="onSuggestionClick(index)"
                                                    ngPreserveWhitespaces
                                                >
                                                    <span class="text" [innerHTML]="match.value | mark: this.lookupQuery.value"></span>
                                                </button>
                                            </li>
                                        </ul>
                                        <ul *ngIf="!suggestions && !suggestionsError">
                                            <li *ngFor="let group of nullLists.get(10)">
                                                <button disabled>
                                                    <span class="text">
                                                        <egov-text-ui-placeholder [length]="30" [lengthThreshold]="10"></egov-text-ui-placeholder>
                                                    </span>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <egov-shape-ui-placeholder *ngIf="(stateLoaded$ | async) !== true" shape="square" [shine]="true"></egov-shape-ui-placeholder>
                    </div>
                    <ng-template #serviceUnavailable>
                        <div class="service-unavailable">
                            <h2><mat-icon>block</mat-icon> Service Unavailable</h2>
                            <div
                                class="formatted"
                                [innerHTML]="(lookupUnavailabilityMessage$ | async) ? ((lookupUnavailabilityMessage$ | async)! | MarkdownToHtml) : null"
                            ></div>
                        </div>
                    </ng-template>
                </form>
                <div
                    class="instructions"
                    *ngIf="(serviceIsUnavailable$ | async) !== true && (selectedTaxServiceIsUnavailable$ | async) !== true"
                    ngPreserveWhitespaces
                >
                    <ng-container *ngIf="stateLoaded$ | async; else instructionsPlaceholder">
                        {{ fieldInstructions$ | async }}
                    </ng-container>
                    <ng-template #instructionsPlaceholder>
                        <egov-text-ui-placeholder [length]="50"></egov-text-ui-placeholder>
                    </ng-template>
                </div>
                <egov-messages
                    *ngIf="showMessages$ | async | waitABit: { initial: false, delay: 300, immediate: !(showMessages$ | async) }"
                    [messages]="serviceMessages$ | async"
                    class="formatted"
                ></egov-messages>
            </div>
            <div class="suggestions-placeholder" [style.height]="suggestionsExcess | waitABit"></div>
        </div>
        <div class="bottom" [class.hidden]="showPage$ | async | waitABit: { initial: false, delay: 700, immediate: showPage$ | async }">
            <div class="content">
                <app-powered-by *ngIf="(stateLoaded$ | async) && !(viewport.mobileNavigation$ | async)" align="left"></app-powered-by>
                <div *ngIf="(hasMoreInfo$ | async) || (stateLoaded$ | async) !== true" class="find-out-more">
                    <div class="legend">
                        <ng-container *ngIf="stateLoaded$ | async">Find out more</ng-container>
                        <egov-text-ui-placeholder *ngIf="(stateLoaded$ | async) !== true">Find out more</egov-text-ui-placeholder>
                    </div>
                    <ul>
                        <li
                            *ngFor="let item of moreInfo$ | async"
                            [class.tooltip]="$any(item)?.content && !$any(item)?.modal"
                            [class.modal]="$any(item)?.content && $any(item)?.modal"
                            [class.link]="$any(item)?.url"
                        >
                            <ng-container *ngIf="item">
                                <a
                                    *ngIf="$any(item).url"
                                    class="name"
                                    href="{{ $any(item).url }}"
                                    target="_blank"
                                    [egovTooltip]="!(platform.touchIsMainInput$ | async) ? urlTooltip : undefined"
                                >
                                    <ng-template #urlTooltip> Click to open in a new tab. </ng-template>
                                    {{ item.name }}
                                    <mat-icon class="open-in-new" *ngIf="platform.touchIsMainInput$ | async"> open_in_new </mat-icon>
                                </a>
                                <ng-container *ngIf="$any(item).content">
                                    <button
                                        *ngIf="!(viewport.phone$ | async)"
                                        class="name"
                                        [egovTooltip]="!((platform.touchIsMainInput$ | async) && $any(item).modal) && tooltipContent"
                                        [appModal]="$any(item)?.modal && $any(item)?.content"
                                    >
                                        <ng-template #tooltipContent>
                                            <ng-container *ngIf="$any(item).modal; else notModal"> Click to expand </ng-container>
                                            <ng-template #notModal>
                                                <div [innerHTML]="$any(item).content"></div>
                                            </ng-template>
                                        </ng-template>
                                        {{ item.name }}
                                    </button>
                                    <button *ngIf="viewport.phone$ | async" class="name" [appModal]="$any(item)?.content">
                                        {{ item.name }}
                                    </button>
                                </ng-container>
                            </ng-container>
                            <egov-text-ui-placeholder *ngIf="!item" length="10" lengthThreshold="5"></egov-text-ui-placeholder>
                        </li>
                    </ul>
                </div>
                <app-feedback-button
                    *ngIf="(feedbackEnabled$ | async) !== false && !(viewport.mobileNavigation$ | async)"
                    [placeholder]="(stateLoaded$ | async) !== true"
                ></app-feedback-button>
            </div>
            <app-cart-state-bar-space-taker></app-cart-state-bar-space-taker>
        </div>
    </div>
    <div class="page-container" *ngIf="showPage$ | async | waitABit: { initial: false, delay: 600, immediate: showPage$ | async }">
        <div class="mat-app-background formatted" [class.gone]="!(showPage$ | async) | waitABit: { initial: true }" [class.dimmed]="showSuggestions$ | async">
            <app-progress-bar *ngIf="loadingResults$ | async"></app-progress-bar>
            <app-page-toolbar>
                <div left><h2 class="toolbar-title">Accounts</h2></div>
                <ng-container right>
                    <div class="option-buttons" *ngIf="(currentTax$ | async) === 'property-tax'">
                        <ng-container *ngIf="viewport.tablet$ | async">
                            <button mat-button [matMenuTriggerFor]="sortMenu" title="Sort">
                                <span class="label" *ngIf="!currentSort?.active">Sort</span>
                                <span class="label" *ngIf="currentSort?.active === 'account_number'">Account</span>
                                <span class="label" *ngIf="currentSort?.active === 'owner'">Owner</span>
                                <span class="label" *ngIf="currentSort?.active === 'parcel_address'">Address</span>
                                <span class="label" *ngIf="currentSort?.active === 'amount_due'">Amount Due</span>
                                <mat-icon class="right">
                                    {{
                                        currentSort?.active
                                            ? !currentSort?.direction || currentSort!.direction === "desc"
                                                ? "arrow_downward"
                                                : "arrow_upward"
                                            : "sort"
                                    }}
                                </mat-icon>

                                <mat-menu #sortMenu="matMenu" yPosition="below" xPosition="before" overlapTrigger>
                                    <button mat-menu-item [disabled]="!currentSort?.active" (click)="changeSort(null)"> Relevance </button>
                                    <button
                                        mat-menu-item
                                        [disabled]="currentSort?.active === 'account_number'"
                                        (click)="changeSort({ active: 'account_number', direction: 'asc' })"
                                    >
                                        Account Number
                                    </button>
                                    <button
                                        mat-menu-item
                                        [disabled]="currentSort?.active === 'owner'"
                                        (click)="changeSort({ active: 'owner', direction: 'asc' })"
                                    >
                                        Owner
                                    </button>
                                    <button
                                        mat-menu-item
                                        [disabled]="currentSort?.active === 'parcel_address'"
                                        (click)="changeSort({ active: 'parcel_address', direction: 'asc' })"
                                    >
                                        Address
                                    </button>
                                    <button
                                        mat-menu-item
                                        [disabled]="currentSort?.active === 'amount_due'"
                                        (click)="changeSort({ active: 'amount_due', direction: 'desc' })"
                                    >
                                        Amount Due
                                    </button>
                                    <mat-divider></mat-divider>
                                    <ng-container *ngIf="currentSort?.active">
                                        <button
                                            mat-menu-item
                                            [disabled]="currentSort?.direction && currentSort!.direction === 'asc'"
                                            (click)="changeSort({ active: currentSort!.active, direction: 'asc' })"
                                        >
                                            Ascending
                                        </button>
                                        <button
                                            mat-menu-item
                                            [disabled]="!currentSort?.direction || currentSort!.direction === 'desc'"
                                            (click)="changeSort({ active: currentSort!.active, direction: 'desc' })"
                                        >
                                            Descending
                                        </button>
                                    </ng-container>
                                </mat-menu>
                            </button>
                        </ng-container>
                    </div>
                    <div class="option-buttons" *ngIf="(currentTax$ | async) === 'business-tax'">
                        <button mat-button [matMenuTriggerFor]="sortMenu" title="Sort">
                            <span class="label" *ngIf="!currentSort?.active">Sort</span>
                            <span class="label" *ngIf="currentSort?.active === 'amount_due'">Amount Due</span>
                            <mat-icon class="right">
                                {{
                                    currentSort?.active
                                        ? !currentSort?.direction || currentSort!.direction === "desc"
                                            ? "arrow_downward"
                                            : "arrow_upward"
                                        : "sort"
                                }}
                            </mat-icon>
                            <mat-menu #sortMenu="matMenu" yPosition="below" xPosition="before" overlapTrigger>
                                <button mat-menu-item [disabled]="!currentSort?.active" (click)="changeSort(null)">Relevance</button>
                                <button
                                    mat-menu-item
                                    [disabled]="currentSort?.active === 'amount_due'"
                                    (click)="changeSort({ active: 'amount_due', direction: 'desc' })"
                                >
                                    Amount Due
                                </button>
                                <mat-divider></mat-divider>
                                <button
                                    *ngIf="currentSort"
                                    mat-menu-item
                                    [disabled]="currentSort.direction === 'asc'"
                                    (click)="changeSort({ active: currentSort.active, direction: 'asc' })"
                                >
                                    Ascending
                                </button>
                                <button
                                    *ngIf="currentSort"
                                    mat-menu-item
                                    [disabled]="currentSort.direction === 'desc'"
                                    (click)="changeSort({ active: currentSort.active, direction: 'desc' })"
                                >
                                    Descending
                                </button>
                            </mat-menu>
                        </button>
                    </div>
                </ng-container>
            </app-page-toolbar>
            <div class="page-content content-column">
                <ppt-lookup-results
                    *ngIf="(currentTax$ | async) === 'property-tax'"
                    [queryData]="{
                        query: currentQuery$ | async,
                        sort: currentSort?.active,
                        direction: currentSort?.direction
                    }"
                    (sortChanged)="changeSort($event)"
                    (lookupStart)="lookupStarted()"
                    (resultsUpdated)="resultsUpdated()"
                    (lookupError)="lookupError()"
                ></ppt-lookup-results>
                <btax-results
                    *ngIf="(currentTax$ | async) === 'business-tax'"
                    [queryData]="{
                        query: currentQuery$ | async,
                        sort: currentSort?.active,
                        direction: currentSort?.direction
                    }"
                    (lookupStart)="lookupStarted()"
                    (resultsUpdated)="resultsUpdated()"
                    (lookupError)="lookupError()"
                ></btax-results>
            </div>
            <app-data-disclaimer [disclaimers]="[disclaimer$ | async]"></app-data-disclaimer>
            <app-bottom-info></app-bottom-info>
            <app-cart-state-bar-space-taker></app-cart-state-bar-space-taker>
        </div>
    </div>
</article>
